module.exports = __webpack_public_path__ + "img/primary.9bb2a116.png";